module.exports = __webpack_public_path__ + "static/media/nimes_amphi_tn.cf3fb232.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/nimes_amphi_tn.jpg
// module id = 730
// module chunks = 0